import { useSaveInsightPage } from "@radarly/core/insight-pages/use-cases";
import { useProject } from "@radarly/core/project/context";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import { WizardConfiguration } from "@radarly/models/insight-pages/wizard/model/configuration";
import { useWizardGenerator } from "./useWizardGenerator";

export function useWizardInsightPageGenerator(template: WizardTemplate) {
  const project = useProject();
  const { setInsightPage } = useSaveInsightPage();
  const { generateInsightPage: _generateInsightPage } = useWizardGenerator();
  const generateInsightPage = async (configuration: WizardConfiguration) => {
    return await setInsightPage({
      project: project.id,
      page: _generateInsightPage(template, configuration),
      template: template.id,
    });
  };
  return {
    generateInsightPage,
  };
}
